export default __webpack_public_path__ + "static/lusterko-ee506ef3d877cadce6a373a6c6246a24.jpg";